export default "<h2 style=\"color:red;\" *ngIf=\"errMsg\" class=\"text-center\">{{errMsg}}</h2>\n"